export default "__VITE_ASSET__B1X4RfEF__"